import { h } from 'preact';

const AkoaLink = ({ setIsOpenAkoa, formSubmited }) => {
  const handleViewClick = (e) => {
    e.preventDefault();
    setIsOpenAkoa(true);
  };

  return (
    <div className={`text-center col-span-12`}>
      <a
        href="#"
        className="flex items-center mb-5 laptop:mb-[17px] text-accent-1 font-m-12 laptop:font-m-14 relative justify-center"
        onClick={handleViewClick}
      >
        <span className="font-r-12 mr-2">
          {formSubmited
            ? 'Review AKOA Agreement'
            : 'To buy this product you must accept the AKOA agreement'}
        </span>
      </a>
    </div>
  );
};

export default AkoaLink;
